import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataService } from "../../../../../services/data.service";
import { SpinnerService } from "shared-components";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-grid-estadisticas-etiquetado-pd",
  templateUrl: "./grid-estadisticas-etiquetado-pd.component.html",
})
export class GridEstadisticasEtiquetadoPdComponent implements OnInit {
  private readonly _DEFAULT_ITEMS_PER_PAGE = 5;

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 1;
  public totalItems: number;
  public firstItemList = 0;
  public lastItemList = this.itemsPerPage;
  public readonly visiblePages = 3;

  public data;

  public showPais = false;
  public showDenominacion = false;
  public showCampanya = false;
  public showEtiquetador = false;

  public desPais;
  public desDenominacion;
  public desCampanya;
  public desEtiquetador;

  @Input() titulo: string;
  @Input() dataGrid: any;

  @Output() refresh = new EventEmitter<boolean>();

  constructor(
    private readonly _translate: TranslateService,
    private readonly _dataService: DataService,
    private readonly _spinnerService: SpinnerService
  ) {}

  ngOnInit() {
    this.getDataGrid();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public getDataGrid() {
    console.log("dataGrid::", this.dataGrid);
    let filters = {
      lsPaisId: this.dataGrid.paisId,
      lsDenominacionId: this.dataGrid.denominacionId,
      etiquetadorId: this.dataGrid.etiquetadorId,
    };

    console.log("filters::", filters);
    this.desDenominacion = this.dataGrid.denominacion
      ? this.dataGrid.denominacion
      : "";
    this.desPais = this.dataGrid.pais ? this.dataGrid.pais : "";
    this.desEtiquetador = this.dataGrid.etiquetador
      ? this.dataGrid.etiquetador
      : "";

    this._spinnerService.showSpinner();
    this._dataService[this.dataGrid.service](filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        console.log("resp", resp);
        if (resp) {
          resp = resp.some((a) => a.lsEtqAnyoPaisDenominacionDto)
            ? resp
                .map((c) => c.lsEtqAnyoPaisDenominacionDto)
                .reduce((acc, curr) => acc.concat(curr), [])
            : resp;
          if (this.desPais == "")
            this.showPais = resp.some((a) => a.paisId) ? true : false;
          if (this.desDenominacion == "")
            this.showDenominacion = resp.some((a) => a.denominacionId)
              ? true
              : false;
          this.showCampanya = resp.some((a) => a.anyo) ? true : false;
          if (this.desEtiquetador == "")
            this.showEtiquetador = resp.some((a) => a.etiquetadorId)
              ? true
              : false;
          this.totalItems = resp.length;
          this.data = resp;
        }
      });
  }

  public pageChange(page) {
    this.currentPage = page;
    this.firstItemList = this.itemsPerPage * (page - 1);
    this.lastItemList = this.itemsPerPage * page;
  }

  public itemsPerPageChange(items) {
    this.currentPage = 1;
    this.itemsPerPage = items;
    this.firstItemList = 0;
    this.lastItemList = items;
  }

  public close() {
    this.refresh.emit(true);
  }
}
